import React, { useEffect, useState } from "react";
import { Tooltip } from "antd";
import Widget from "../../Widget/Widget";
import SettingsModal from "../../Modal/SettingsModal";
import PercentageSummarySettings from "../WidgetsSettings/PercentageSummary/PercentageSummarySettingsModal";
import infoIcon from "../../../assets/cp/info.png";
import { getFile, getFileBytes } from "../../../services/restAPI/RestApi";
import { getFormWithData } from "../../../services/restAPI/FormsV3";
import "./percentageSummary.less";

const PercentageSummary = ({ value, role }) => {
   const [imgSrcFromFileId, setImgSrcFromFileId] = useState(null);
   const [fieldValueFromForm, setFieldValueFromForm] = useState(null);
   const contentContainerRef = React.useRef();
   useEffect(() => {
      if (!value.imageUrl && value.imageFileId) {
         getFileBytes(value.imageFileId).then((res) => {
            if (res.data.includes("<svg")) {
               const blob = new Blob([res.data], { type: "image/svg+xml" });
               setImgSrcFromFileId(URL.createObjectURL(blob));
            } else getFile(value.imageFileId).then((res) => setImgSrcFromFileId(res.data));
         });
      }
   }, [value.imageFileId, value.imageUrl]);

   useEffect(() => {
      if (value.formId && value.dataId && value.humanFieldName) {
         getFormWithData(value.formId, value.dataId)
            .then((res) => {
               const fields = res?.data?.fields || [];
               const field = fields.find(
                  (f) =>
                     f.hid === value.humanFieldName ||
                     f.label === value.humanFieldName ||
                     f.modelField?.name === value.humanFieldName ||
                     f.humanFieldName === value.humanFieldName,
               );
               if (field) {
                  let val = null;
                  if (field.value && typeof field.value === "object") {
                     val =
                        field.value.originalValue !== undefined
                           ? field.value.originalValue
                           : field.value.decoratedValue;
                  } else {
                     val = field.value;
                  }
                  setFieldValueFromForm(val);
               }
            })
            .catch((err) => {});
      }
   }, [value.formId, value.dataId, value.humanFieldName]);

   const { xsImageSize, smImageSize } = value;
   const contentBox = contentContainerRef?.current?.clientWidth;
   const imageWidth = xsImageSize !== 0 ? (xsImageSize / 100) * contentBox + "px" : "unset";
   const imageHeight = smImageSize !== 0 ? (smImageSize / 100) * contentBox + "px" : "unset";

   return (
      <div className="percentageSummaryWidget">
         <Widget
            styleName="gx-m-0"
            bgColor={value.backgroundColourHex}
            className="newsletter-card"
            role={role}
            extra={
               <div className="newsletter-extra">
                  {role === "OWNER" || role === "MODERATOR" ? (
                     <SettingsModal
                        widgetName={value.name}
                        widgetId={value.id}
                        icon="setting"
                        deleteIcon="true"
                        children={<PercentageSummarySettings value={value} />}
                     />
                  ) : null}
               </div>
            }
         >
            <div ref={contentContainerRef} className="newsletter-content">
               {value.tooltipText ? (
                  <Tooltip title={value.tooltipText}>
                     <img
                        src={infoIcon}
                        alt="info"
                        className="newsletter-info-icon"
                        style={{ cursor: "pointer" }}
                     />
                  </Tooltip>
               ) : (
                  <img src={infoIcon} alt="info" className="newsletter-info-icon" />
               )}
               <div className="newsletter-header">
                  <div className="newsletter-image-container">
                     {value.imageUrl || imgSrcFromFileId ? (
                        <img
                           src={value.imageUrl || imgSrcFromFileId}
                           width={imageWidth}
                           height={imageHeight}
                           className="newsletter-image"
                           alt=""
                        />
                     ) : (
                        <div className="newsletter-icon-placeholder">
                           <i className="icon icon-sent" />
                        </div>
                     )}
                  </div>
                  <div className="newsletter-info">
                     <span className="newsletter-value">
                        {fieldValueFromForm !== null ? fieldValueFromForm : 0}
                     </span>
                     <p className="newsletter-description">{value.titleKey}</p>
                  </div>
               </div>
            </div>
         </Widget>
      </div>
   );
};

export default PercentageSummary;
